import React, { Component } from "react";
import axios from "axios";
import { API_BASE_URL, TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { REFRESH_ICON } from "assets/constants/Icons";
import Spinner from "components/Spinner";
import MaterialTable from "material-table";
import { validateIsoDateFormat, defaultFormatDateTime, defaultFormatDate,epochToIndianTime, defaultFormatDateTimeWithSeconds } from "lib/utils";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import moment from "moment";
import ShowToast from 'components/ShowToast';
import { Cancel } from "@material-ui/icons";

export class RawMeterReadingPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            meterRawReadings: [],
            copySuccess: "",
            selectDeviceType: "",
            meterSerialNo: "",
            selectDeviceTypeOptions: [
                { value: "153rwm", label: "153RWM" },
                { value: "151bo", label: "151BO" },
                { value: "153uif", label: "153UIF" },
                { value: "151mfmp", label: "151MFMP" },
                { value: "153ucw", label: "153UCW" },
                { value: "171bpt", label: "171BPT" },
                { value: "138radar", label: "138RADAR" },
                { value: "oht", label: "OHT" },
            ],
            endDate: moment().endOf('day').toDate(),
            startDate: moment().endOf('day').toDate(),
            error: {},
            maxEndDate: new Date(),
            totalCount: 0,
            currentPage: 0,
            pageSize: 150,
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        const meterRawReadings = await this.getMeterRawReadings(1, this.state.pageSize);
        this.setState({
            meterRawReadings: meterRawReadings.data.result,
            totalCount: meterRawReadings.data.totalCount || meterRawReadings.data.result.length,
            isLoading: false,
        });
    }

    getMeterRawReadings = async (page = 1, limit = 150) => {
        return await axios.get(`${API_BASE_URL}/all/device/raw/readings?page=${page}&limit=${limit}`);
    };



    handlePageChange = async (page, pageSize) => {
        this.setState({ isLoading: true });
        const meterRawReadings = await this.getMeterRawReadings(page + 1, pageSize);
        this.setState({
            meterRawReadings: meterRawReadings.data.result,
            totalCount: meterRawReadings.data.totalCount,
            currentPage: page,
            pageSize: pageSize,
            isLoading: false
        });
    }

   handleCopy = (text) => {
  const textToCopy = JSON.stringify(text, null, 2);

  try {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    textarea.style.position = "fixed";
    textarea.style.opacity = 0;       
    document.body.appendChild(textarea);

    textarea.select();
    const success = document.execCommand("copy");
    document.body.removeChild(textarea);

    if (success) {
      this.setState({ copySuccess: "Copied!" });
      ShowToast("Copied!", TYPE_SUCCESS, INTERVAL);
      setTimeout(() => this.setState({ copySuccess: "" }), 1500);
    } else {
      throw new Error("Copy command failed");
    }
  } catch (err) {
    console.error("Copy failed:", err);
    ShowToast("Press Ctrl+C to copy manually", TYPE_FAIL, INTERVAL);
  }
};

    selectDeviceTypeChangeHandler = (event) => {
        this.setState({
            selectDeviceType: { label: event.label, value: event.value },
        })
    }

    serialNumChangeHandler = (event) => {
        this.setState({
            meterSerialNo: event.target.value,
        })
    }

    isFormRawReadingsValid = () => {
        let isValid = true;
        let error = {};

        if (!this.state.selectDeviceType) {
            isValid = false;
            error.selectDeviceType = "Please select device type";
        }
        if (!this.state.meterSerialNo) {
            isValid = false;
            error.meterSerialNo = "Please enter serial number";
        }

        this.setState({
            error
        });

        return isValid;
    }

    getRawReportReadings = async () => {
        if (this.isFormRawReadingsValid()) {
            this.setState({
                isLoading: true,
                meterRawReadings: []
            })

            const readingRawData = await axios.get(`${API_BASE_URL}/filter/raw/readings/${moment(this.state.startDate).valueOf()}/${moment(this.state.endDate).valueOf()}/${this.state.selectDeviceType.label}/${this.state.meterSerialNo}`);
            if (readingRawData.data.result.length > 0) {
                ShowToast('Raw Readings Report created successfully', TYPE_SUCCESS, INTERVAL, null, "");
                this.setState({
                    meterRawReadings: readingRawData.data.result,
                    totalCount: readingRawData.data.totalCount || readingRawData.data.result.length,
                    isLoading: false,
                })
            }
            else {
                ShowToast('Raw Readings not found', TYPE_FAIL, INTERVAL, null, "");
                const meterRawReadings = await this.getMeterRawReadings(1, this.state.pageSize);
                this.setState({
                    meterRawReadings: meterRawReadings.data.result,
                    totalCount: meterRawReadings.data.totalCount,
                    isLoading: false,
                    selectDeviceType: "",
                    meterSerialNo: "",
                });
            }
        }
    }

    cancelRawReadings = async () => {
        const meterRawReadings = await this.getMeterRawReadings(1, this.state.pageSize);
        this.setState({
            meterRawReadings: meterRawReadings.data.result,
            totalCount: meterRawReadings.data.totalCount,
            isLoading: false,
            selectDeviceType: "",
            meterSerialNo: "",
            endDate: moment().endOf('day').toDate(),
            startDate: moment().endOf('day').toDate(),
            error: {}
        });
    }

    handleFromDateChange = (date) => {
        this.setState({
            startDate: date,
        })
    }

    handleToDateChange = (date) => {
        this.setState({
            endDate: date,
        })
    }

    handleRefresh = async () => {
        this.setState({ isLoading: true })
      const rawreadingdata =  await this.getMeterRawReadings(1, this.state.pageSize);
        this.setState({ 
            meterRawReadings: rawreadingdata.data.result,
            isLoading: false })
    }

    render() {
        const { isLoading, meterRawReadings } = this.state;

        if (isLoading) return <Spinner />;

        const tableData = meterRawReadings.filter((element) => element?.meter_serial_no && element?.device_type).map((element) => ({
            created_date_time: element.raw_data?.nts ? epochToIndianTime(element.raw_data?.nts * 1000) :defaultFormatDateTime(element.created_date_time),
            web_received_date_time: validateIsoDateFormat(element.created_date_time) ? defaultFormatDateTimeWithSeconds(element.created_date_time) : element.created_date_time,
            serial_number: element.meter_serial_no,
            device_type: element.device_type,
            raw_data_object: element.raw_data || {},
            raw_data_string: JSON.stringify(element.raw_data || {}, null, 2),
            raw_data_export: JSON.stringify(element.raw_data || {})
        }));

        return (
            <div>
                <div className="main-content">
                    <div className="live-sync-icon-and-text-container">
                        <div className="" >
                        </div>
                        <div className="flow-heading" >RAW READINGS</div>
                        <div className="live-sync-info">
                            <i
                                onClick={this.handleRefresh}
                                className={`${REFRESH_ICON}`}
                            ></i>
                        </div>
                    </div>
                    <div className="list-wrapper"  >
                        <div className="pt-5 mt-5 mb-2 pb-5 border list-table-div">
                            <div className="row">
                                <div className="addUser">
                                    <label className="form-label">Select Device Type <span className="text-danger">*</span></label>
                                    <Select
                                        className="site-select-dropdown"
                                        value={this.state.selectDeviceType}
                                        placeholder="Select Device Type"
                                        options={this.state.selectDeviceTypeOptions}
                                        onChange={this.selectDeviceTypeChangeHandler}
                                        onMenuOpen={this.handleMenuOpen}
                                        onMenuClose={this.handleMenuClose}
                                        menuPlacement="bottom"
                                    />
                                    <div className="text-danger error-msg">
                                        {this.state.error.selectDeviceType}
                                    </div>
                                </div>
                                <div className="addUser">
                                    <label className="form-label">Meter Serial Number <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control brand-font p-3 placeholderColor"
                                        value={this.state.meterSerialNo}
                                        onChange={this.serialNumChangeHandler}
                                        placeholder="Enter Serial Number"
                                        type="number"
                                    />
                                    <div className="text-danger error-msg">
                                        {this.state.error.meterSerialNo}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="addUser">
                                    <label className="form-label">From Date <span className="text-danger"></span></label>
                                    <div className="calender-div">
                                        <span className="icon fa-calendar" />
                                        <DatePicker
                                            className="form-control brand-font p-3"
                                            selected={this.state.startDate}
                                            onChange={this.handleFromDateChange}
                                            timeIntervals={1}
                                            timeCaption="time"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText="Please select date"
                                            maxDate={this.state.maxEndDate}
                                        />
                                    </div>
                                </div>

                                <div className="addUser">
                                    <label className="form-label">To Date <span className="text-danger"></span></label>
                                    <div className="calender-div">
                                        <span className="icon fa-calendar" />
                                        <DatePicker
                                            className="form-control brand-font p-3"
                                            selected={this.state.endDate}
                                            onChange={this.handleToDateChange}
                                            timeIntervals={1}
                                            timeCaption="time"
                                            dateFormat="dd/MM/yyyy"
                                            maxDate={this.state.maxEndDate}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center mt-4">
                                <div className="col-auto">
                                    <button
                                        id="button"
                                        style={{ fontFamily: '"Roboto", "Poppins", sans-serif', fontSize: "12.5px", border: "1px solid #ccc", }}
                                        className="btn btn-primary btn-lg px-3 py-2 fw-bold"
                                        onClick={() => this.getRawReportReadings()}
                                    >
                                        Get Report
                                    </button>
                                </div>
                                <div className="col-auto">
                                    <button
                                        id="button"
                                        style={{
                                            fontFamily: '"Roboto", "Poppins", sans-serif',
                                            fontSize: "12.5px",
                                            backgroundColor: "#d3d3d3",
                                            color: "#000000",
                                            border: "1px solid #ccc",
                                        }}
                                        className="btn btn-lg px-3 py-2 fw-bold"
                                        onClick={() => this.cancelRawReadings()}
                                    >
                                        CANCEL
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div className="border list-table-div">
                        {tableData.length > 0 ? (
                            <MaterialTable
                                columns={[
                                    {
                                        title: "Network Date And Time",
                                        field: "created_date_time",
                                        width: "5%",
                                        cellStyle: { color: "#000000", fontSize: 14 },
                                    },
                                       {
                                        title: "Web Receive Date And Time",
                                        field: "web_received_date_time",
                                        width: "5%",
                                        cellStyle: { color: "#000000", fontSize: 14 },
                                    },
                                    {
                                        title: "Serial Number",
                                        field: "serial_number",
                                        width: "3%",
                                        cellStyle: { color: "#000000", fontSize: 14 },
                                    },
                                    {
                                        title: "Device Type",
                                        field: "device_type",
                                        width: "3%",
                                        cellStyle: { color: "#000000", fontSize: 14 },
                                    },
                                    {
                                        title: "Raw Data",
                                        field: "raw_data_export",
                                        cellStyle: { color: "#808080", fontSize: 14 },
                                        render: (rowData) => (
                                            <div style={{ position: 'relative' }}>
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '4px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 2,
                                                }}>
                                                    <Tooltip title="Copy">
                                                        <IconButton
                                                            onClick={() => this.handleCopy(rowData.raw_data_object)}
                                                            size="small"
                                                            style={{ backgroundColor: '#fff' }}
                                                        >
                                                            <FileCopyIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                                <pre
                                                    style={{
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                        fontFamily: 'monospace',
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        margin: 0,
                                                        paddingTop: '36px',
                                                        paddingRight: '16px',
                                                    }}
                                                >
                                                    {rowData.raw_data_string}
                                                </pre>
                                            </div>
                                        ),
                                    }
                                ]}
                                data={tableData}
                                options={{
                                    headerStyle: {
                                        color: "#0070C0",
                                        fontWeight: "bold",
                                        fontSize: 15,
                                    },
                                    columnsButton: true,
                                    pageSize: this.state.pageSize,
                                    pageSizeOptions: [150, 200, 300, 400, 500],
                                    exportButton: {
                                        csv: true,
                                        pdf: false
                                    },
                                    exportAllData: true,
                                    exportFileName: this.state.selectDeviceType ? `${this.state.selectDeviceType.label}-${this.state.meterSerialNo}-RawData` : `All-Device-RawData`,
                                }}
                                onChangePage={this.handlePageChange}
                                onChangeRowsPerPage={this.handlePageChange}
                                page={this.state.currentPage}
                                totalCount={this.state.totalCount}
                            />
                        ) : (
                            <div className="text-center pt-2">
                                <label>No records found!</label>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default RawMeterReadingPage;